export default "__VITE_ASSET__BVipcCOa__"